import { addLightness } from '../../../colorMutators/colorMutators/index.js';

const TextLightInput = '#000000';
const TextDarkInput = '#ffffff';
const TextsLightValues = Object.freeze({
    positive: '#ffffff',
    negative: '#000000',
    base: TextLightInput,
    tint1: addLightness(TextLightInput, 29.8),
    tint2: addLightness(TextLightInput, 50),
    tint3: addLightness(TextLightInput, 60),
});
const TextsDarkValues = Object.freeze({
    positive: '#000000',
    negative: '#ffffff',
    base: TextDarkInput,
    tint1: addLightness(TextDarkInput, -30),
    tint2: addLightness(TextDarkInput, -50),
    tint3: addLightness(TextDarkInput, -60),
});

export { TextsDarkValues, TextsLightValues };
